import { RoomType } from '@/types/profile'

/**
 * ルーム種別の語彙変換ユーティリティ。
 *
 * DB/API 側は `business / matchmaking / career`（ER図・t_user_profile.event_type に準拠）、
 * 画面側は `business / dating / job` を使う。過去に画面側の語彙のまま
 * t_rooms.category_type へ保存されたデータが存在するため、
 * 正規化は双方の語彙を受け付ける。
 */

export type ApiCategoryType = 'business' | 'matchmaking' | 'career'

/** API/DB の値を画面用の RoomType に正規化する。不明な値は business にフォールバック。 */
export const toRoomType = (value: string | null | undefined): RoomType => {
  switch (value) {
    case 'matchmaking':
    case 'dating':
      return 'dating'
    case 'career':
    case 'job':
      return 'job'
    case 'business':
      return 'business'
    default:
      return 'business'
  }
}

/** 画面用の RoomType を API/DB へ送る値に変換する。 */
export const toApiCategoryType = (value: string | null | undefined): ApiCategoryType => {
  switch (toRoomType(value)) {
    case 'dating':
      return 'matchmaking'
    case 'job':
      return 'career'
    default:
      return 'business'
  }
}
